import type { CategoryTree } from "../models/category";

export const categoryTreeMind: CategoryTree = {
  mab: {
    name: "Mind & Behavior",
    subcategories: {
      cog: { name: "Cognitive Processes" },
      soc: { name: "Social Psychology" },
      dev: { name: "Developmental Stages" },
      emo: { name: "Emotional Intelligence" },
      neu: { name: "Neuroscience" },
      psy: { name: "Psychological Theories" },
      per: { name: "Personality" },
      beh: { name: "Behavioral Science" },
      dec: { name: "Decision Making" },
      con: { name: "Consciousness" },
      mem: { name: "Learning & Memory" },
      mot: { name: "Motivation & Willpower" },
    },
  },
  phv: {
    name: "Philosophy",
    subcategories: {
      eth: { name: "Ethics" },
      epi: { name: "Epistemology" },
      met: { name: "Metaphysics & Reality" },
      pol: { name: "Political Philosophy" },
      aes: { name: "Aesthetics" },
      log: { name: "Logic" },
      hum: { name: "Existentialism" },
      anc: { name: "Classical Thought" },
      mod: { name: "Modern Philosophy" },
      rel: { name: "Philosophy of Religion" },
      sci: { name: "Philosophy of Science" },
      min: { name: "Philosophy of Mind" },
    },
  },
  sag: {
    name: "Society",
    subcategories: {
      soc: { name: "Sociological Structures" },
      pol: { name: "Political Systems" },
      law: { name: "Legal Frameworks" },
      gov: { name: "Public Policy" },
      his: { name: "Historical Events" },
      ant: { name: "Cultural Anthropology" },
      urb: { name: "Urban Studies" },
      dem: { name: "Demographics" },
      cri: { name: "Criminology" },
      hum: { name: "Human Rights" },
      civ: { name: "Civic Engagement" },
      dev: { name: "Social Change" },
    },
  },
  eag: {
    name: "Economics",
    subcategories: {
      mic: { name: "Microeconomics" },
      mac: { name: "Macroeconomics" },
      fin: { name: "Finance" },
      int: { name: "International Trade" },
      beh: { name: "Behavioral Economics" },
      dev: { name: "Development Economics" },
      bus: { name: "Business Principles" },
      sup: { name: "Supply Chains" },
      ent: { name: "Entrepreneurship" },
      glo: { name: "Globalization" },
      env: { name: "Environmental Economics" },
      pub: { name: "Public Finance" },
    },
  },
};
